module.exports = __webpack_public_path__ + "static/media/youtube-orange.606ceae8.svg";